import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../../../assets/css/student/NgoScreen/CaseCategories.css';

const CaseCategories = () => {
  const categories = [
    {
      icon: '🎓',
      title: 'Fee Support',
      description: 'Covers tuition fees for deserving students directly to educational institutions.',
    },
    {
      icon: '📚',
      title: 'Books Support',
      description: 'Provides essential books and stationery for students who cannot afford them.',
    },
    {
      icon: '🏦',
      title: 'Direct Institute Payment',
      description: 'NGOs conduct field visits and verify cases — funds go straight to schools.',
    },
    {
      icon: '📊',
      title: 'Impact Tracking',
      description: 'Verified cases are tracked end-to-end so donors see real impact in real-time.',
    },
  ];

  return (
    <section className="cat-section" id="categories">
      <Container>
        {/* Header */}
        <div className="cat-header">
          <span className="cat-section-label">Case Categories</span>
          <h2 className="cat-title">What We Fund</h2>
          <p className="cat-subtitle">
            From tuition fees to books — every educational need covered through
            our verified program.
          </p>
        </div>

        {/* Cards */}
        <Row className="g-4 justify-content-center">
          {categories.map((cat, index) => (
            <Col xl={3} lg={3} md={6} sm={12} key={index}>
              <Card className="cat-card">
                <Card.Body className="p-4">
                  <div className="cat-icon-box">
                    <span className="cat-icon">{cat.icon}</span>
                  </div>
                  <h5 className="cat-card-title">{cat.title}</h5>
                  <p className="cat-card-desc">{cat.description}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default CaseCategories;